/** Default REST API root (includes `/api`). */
const DEFAULT_API_BASE_URL = "https://fingent-api.onrender.com/api";

function trimTrailingSlashes(url: string): string {
  return url.replace(/\/+$/, "");
}

/**
 * Resolved API base for fetch calls. Uses `VITE_API_BASE_URL`, then legacy `VITE_API_URL`, then production.
 */
export const API_BASE_URL = trimTrailingSlashes(
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() ||
    (import.meta.env.VITE_API_URL as string | undefined)?.trim() ||
    DEFAULT_API_BASE_URL,
);
